import { StrictMode } from "react";
import "./landing/public.css";
import "./landing/landing-direction.css";
import "./landing/landing-motion.css";
import "./landing/task-film-library.css";
import "./landing/pricing-calculator.css";
import { createRoot, hydrateRoot } from "react-dom/client";
import { isPublicPath, publicPathname } from "./landing/paths";
const root = document.getElementById("root");
if (!root) throw new Error("#root not found");
async function start(host: HTMLElement) {
  if (isPublicPath(publicPathname(window.location.pathname))) {
    const { PublicApp } = await import("./landing/PublicApp");
    if (host.hasChildNodes()) hydrateRoot(host, <PublicApp />);
    else createRoot(host).render(<PublicApp />);
  } else {
    const status = document.createElement("p");
    status.setAttribute("role", "status");
    status.textContent = "Opening Scorio…";
    host.replaceChildren(status);
    const [{ App }, { registerPwa }] = await Promise.all([
      import("./App"),
      import("./pwa/register"),
      import("./styles.css"),
    ]);
    registerPwa();
    host.replaceChildren();
    createRoot(host).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  }
}
void start(root);
